module.exports = __webpack_public_path__ + "media/customizations/regencyatauburnstation/logo-23d88848008428990eb9cdba040cab03.png";